export const sideTypes = {
  me: "Mine",
  opponent: "Them",
  neutral: "Neutral",
};
export type SideType = (typeof sideTypes)[keyof typeof sideTypes];
